/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {ConfirmModalConfigurationModel} from '../../../shared/confirm-modal/confirm-modal/models/confirm-modal-configuration.model';
import {AlertNotificationSeverity} from '../../../alert-notification-severity.model';

/**
 * Reject modal configuration (supplier)
 */
const rejectModalConfiguration: ConfirmModalConfigurationModel = {
    title: 'Rejection confirmation',
    primaryActionTitle: 'Send rejection',
    secondaryActionTitle: 'Discard',
    alertNotificationSeverity: AlertNotificationSeverity.INFORMATION,
    body: {
        notes: {
            placeholder: 'Please write your reason for rejection here',
            isNotesMandatory: true,
            height: 110,
            maxNumberCharacters: 320,
            labelNotes: 'Could you explain your reason for rejection?'
        },
        manualChecks: {
            options: ['By rejecting this agreement you will not be able to undo this action.']
        }
    }
};

/**
 * Reject modal configuration (customer)
 */
const rejectModalConfigurationCustomer: ConfirmModalConfigurationModel = {
    title: '4 eyes rejection confirmation',
    primaryActionTitle: 'Send rejection',
    secondaryActionTitle: 'Discard',
    alertNotificationSeverity: AlertNotificationSeverity.INFORMATION,
    body: {
        notes: {
            placeholder: 'Please write your reason for rejection here',
            isNotesMandatory: true,
            height: 110,
            maxNumberCharacters: 320,
            labelNotes: 'Could you explain your reason for rejection?'
        },
        manualChecks: {
            options: ['By rejecting this agreement based on 4 eyes principal you will not be able to undo this action. ']
        }
    }
};

/**
 * Accept modal configuration (supplier)
 */
const acceptModalConfiguration: ConfirmModalConfigurationModel = {
    title: 'Acceptance confirmation',
    primaryActionTitle: 'Accept',
    secondaryActionTitle: 'Discard',
    alertNotificationSeverity: AlertNotificationSeverity.SUCCESS,
    body: {
        notes: {
            placeholder: 'Please write your comment here (optional)...',
            isNotesMandatory: false,
            height: 110,
            maxNumberCharacters: 320,
            labelNotes: 'Would you like to leave a comment about your acceptance?'
        },
        manualChecks: {
            options: ['By accepting this agreement you will not be able to withdraw.']
        }
    }
};

/**
 * Accept modal configuration (customer)
 */
const acceptModalConfigurationCustomer: ConfirmModalConfigurationModel = {
    title: '4 eyes acceptance confirmation',
    primaryActionTitle: 'Accept',
    secondaryActionTitle: 'Discard',
    alertNotificationSeverity: AlertNotificationSeverity.SUCCESS,
    body: {
        notes: {
            placeholder: 'Please write your comment here (optional)...',
            isNotesMandatory: false,
            height: 110,
            maxNumberCharacters: 320,
            labelNotes: 'Would you like to leave a comment about your acceptance?'
        },
        manualChecks: {
            options: ['By accepting this agreement based on 4 eyes principal you will not be able to withdraw.']
        }
    }
};

/**
 * Variable to export configurations
 */
const settlementsModalConfigurations: {
    rejectSupplier: ConfirmModalConfigurationModel;
    acceptSupplier: ConfirmModalConfigurationModel;
    rejectCustomer: ConfirmModalConfigurationModel;
    acceptCustomer: ConfirmModalConfigurationModel;
} = {
    rejectSupplier: rejectModalConfiguration,
    acceptSupplier: acceptModalConfiguration,
    rejectCustomer: rejectModalConfigurationCustomer,
    acceptCustomer: acceptModalConfigurationCustomer
};

export default settlementsModalConfigurations;
